import { render, staticRenderFns } from "./editSpot.vue?vue&type=template&id=5b9b9b0a"
import script from "./editSpot.vue?vue&type=script&lang=js"
export * from "./editSpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports